const STORAGE_KEY = 'resymaid-theme';

function getInitialMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.warn('Theme: localStorage unavailable', e);
  }
  return 'light';
}

function applyTheme(mode) {
  try {
    document.documentElement.classList.remove('theme-light', 'theme-dark');
    document.documentElement.classList.add(`theme-${mode}`);
    document.documentElement.setAttribute('data-theme', mode);
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.warn('Theme: could not apply class', e);
  }
}

const state = {
  mode: getInitialMode(),
};

const getters = {
  themeMode: (state) => state.mode,
  isDark: (state) => state.mode === 'dark',
  isLight: (state) => state.mode === 'light',
  /** Single source of truth for theme-aware logo: dark = logo-full-dark.png, light = logo-full-light.png. Use <AppLogo /> to display. */
  logoUrl: (state) => {
    return state.mode === 'dark'
      ? require('@/assets/brand/logo-full-dark.png')
      : require('@/assets/brand/logo-full-light.png');
  },
};

const mutations = {
  SET_THEME(state, mode) {
    if (mode !== 'dark' && mode !== 'light') return;
    state.mode = mode;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.warn('Theme: could not persist to localStorage', e);
    }
    applyTheme(mode);
  },
};

const actions = {
  initTheme({ state }) {
    applyTheme(state.mode);
  },
  setTheme({ commit }, mode) {
    commit('SET_THEME', mode);
  },
  toggleTheme({ state, commit }) {
    commit('SET_THEME', state.mode === 'dark' ? 'light' : 'dark');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
